import '@mdi/font/css/materialdesignicons.css'
import '@vuepic/vue-datepicker/dist/main.css'
import { createVuetify } from 'vuetify'
import defaults from './defaults'
import theme from './theme'
import date from './date'

// Styles
import 'vuetify/styles'

export default createVuetify({
  defaults,
  theme,
  date,
})
